import React from 'react';
import { lightModeState } from '../../recoil/atoms';
import { useRecoilValue } from 'recoil';
import { UserLocation } from '../../helpers/types';

type Props = {
  item: UserLocation;
};

const UserLocationTableData = ({ item }: Props) => {
  const lightMode = useRecoilValue(lightModeState);
  return (
    <tr
      className={`${
        lightMode ? 'text-gray-600' : 'text-gray-400'
      } text-2xs sm:text-sm`}
    >
      <td
        className={`${
          lightMode ? 'text-black' : 'text-white'
        } border-t-2 border-gray-800 pr-5 pl-4 py-3`}
      >
        {item.state}
      </td>
      <td
        className={`${
          lightMode ? 'text-black' : 'text-white'
        } border-t-2 border-gray-800 pr-5 pl-4 py-3`}
      >
        {item.city}
      </td>
      <td className='border-t-2 border-gray-800 px-4 py-3'>
        {item.impressions}
      </td>
      <td className='border-t-2 border-gray-800 px-4 py-3'>{item.clicks}</td>
      <td className='border-t-2 border-gray-800 px-4 py-3'>{item.ctr}%</td>
      <td className='border-t-2 border-gray-800 px-4 py-3'>${item.avg_cpc}</td>
      <td className='border-t-2 border-gray-800 px-4 py-3'>${item.spend}</td>
      <td className='border-t-2 border-gray-800 px-4 py-3'>
        {item.conversions}
      </td>
      <td className='border-t-2 border-gray-800 px-4 py-3'>
        ${item.cost_per_conversion}
      </td>
    </tr>
  );
};

export default UserLocationTableData;
